import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    createStyles,
    makeStyles,
    Switch,
    TextField,
    Theme,
    Typography,
    Divider,
    Radio,
    RadioGroup,
    FormControl,
    FormLabel,
    FormControlLabel,
    withStyles,
} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {retrieveProfile, selectProfile, updateProfile, updateContact,} from "../registrations/registrationsSlice";
import {selectToken} from "../authentication/authenticationSlice";
import Config from "../../config";
import {retrieveRegistrations, selectRegistration, selectRegistrations, updateRegistration,} from "../registrations/registrationsSlice";
import {Profile as ProfileType, ProfileFactory, ProfileJSON,} from "../../models/models";
import {Registration, RegistrationFactory, RegistrationJSON} from "../../models/models";
import {useSnackbar} from "notistack";
import {retrieveEvent, selectEvent} from "../badge/eventSlice";
import {daysUntilEvent} from "../../utils/dateFunctions";
import {SponsorBanner} from "../../components/sponsorBanner/SponsorBanner";
import {retrieveBranding, selectBranding} from "../badge/brandingSlice";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      paddingBottom: 20,
      paddingLeft: 20,
      paddingRight: 20,
      backgroundColor: theme.palette.background.default,
      overflow: "auto",
    },
    row: {
      display: "flex",
      alignItems: "center",
    },
    rahmenprogrammA: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    rahmenprogrammB: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginLeft: 10,
      component:"ul"
    },
    indicator: {
      height: 10,
      width: 10,
      borderRadius: 5,
      backgroundColor: theme.palette.primary.main,
      marginRight: 10,
    },
    name: {
      fontWeight: "bold",
    },
  })
);

export const Profile = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const profile = useSelector(selectProfile(Config.getInstance().getRegistrationID()));
  const registration = useSelector(selectRegistration(Config.getInstance().getRegistrationID()));
  const registrations = useSelector(selectRegistrations);
  const event = useSelector(selectEvent);
  const brandingPartners = useSelector(selectBranding);

  const authToken = useSelector(selectToken);

  useEffect(() => {
    if (authToken) {
      dispatch(retrieveEvent(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveProfile(authToken,Config.getInstance().getEventID(),Config.getInstance().getRegistrationID()));
      dispatch(retrieveRegistrations(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveBranding(Config.getInstance().getPublicToken(), Config.getInstance().getEventID()));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const profileFactory = new ProfileFactory();
  const registrationFactory = new RegistrationFactory();
  const [mutableProfile, setMutableProfile] = useState<ProfileJSON>(profileFactory.toJSON(profile));
  const [mutableRegistration, setMutableRegistration] = useState<RegistrationJSON>(registrationFactory.toJSON(registration));
  const [showDietaryNeeds, setShowDietaryNeeds] = useState<boolean>(false);

  useEffect(() => {
    if (profile) {
      setMutableProfile(profileFactory.toJSON(profile));
      if (profile.dietaryNeeds === ""){
        setShowDietaryNeeds(false);
      }
      else {
        setShowDietaryNeeds(true);
      }
    }
  }, [JSON.stringify(profileFactory.toJSON(profile))]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (registration) {
      setMutableRegistration(registrationFactory.toJSON(registration));
    }
  }, [JSON.stringify(registrationFactory.toJSON(registration))]);


//deprecated and replaced by save compelte information including the contact
  const saveProfile = (
    authToken: string,
    eventID: string,
    registrationID: string,
    profile: ProfileType
  ) => {
    dispatch(updateProfile(authToken, eventID, registrationID, profile));

    enqueueSnackbar("Profile has been updated.", {
      variant: "success",
    });
  };

  const saveProfileInformation = (
    authToken: string,
    eventID: string,
    registrationID: string,
    profile: ProfileType,
    registration: Registration,
  ) => {

      const participant = registrations.filter(
                                 (registration) => registration.id === Config.getInstance().getRegistrationID())[0];
      const registrationIndex = registrations.indexOf(participant);

      let registrationsCopy = registrations;
      registrationsCopy[registrationIndex] = registration;

      dispatch(updateContact(authToken, eventID, registrationID, profile, registrationsCopy));

      enqueueSnackbar("Profile has been updated.", {
          variant: "success",
      });
    };


  const differenceDays = daysUntilEvent(new Date(event.eventDate));


  return (
    <Box className={classes.container}>
       <SponsorBanner
         businessPartners={brandingPartners}
       />
      <Typography
        variant="h6"
        color="textPrimary"
        style={{ marginTop: 20, marginBottom: 20 }}
      >
        Profil
      </Typography>

      {/*
      <Box style={{ height: 40 }} />
        <Typography
          color="textPrimary"
          align="left"
          style={{ fontWeight: "bold" }}
        >
          Nachmittags Programm
        </Typography>
        <Typography color="textSecondary" align="left">
        {mutableRegistration.portal_access === "Open" ?
          "Bitte wählen Sie eine der folgenden Möglichkeiten"
          : "Das Auswahlfenster wurde bereits geschlossen."
        }
        </Typography>

        <Box className={classes.row}>
          <FormControl>

          <RadioGroup
             value={mutableRegistration.event_option}
             onChange={(event) => setMutableRegistration({
                      ...mutableRegistration,
                      event_option: event.target.value,
                  })}
          >
          <FormControlLabel
             value="bilacon-networking"
             disabled={mutableRegistration.portal_access !== "Open"}
             control={<Radio color="primary" />}
             label={
               <>
               <Box className={classes.rahmenprogrammA}>
                  <Typography
                    color="textPrimary"
                  >
                    Interaktives Rahmenprogramm (Speed2Connect)
                  </Typography>
               </Box>
               <Box className={classes.rahmenprogrammB}>
                  <Typography color="textSecondary">• Allgemeine Anfragen & Problemstellungen</Typography>
                  <Typography color="textSecondary">• Logistik</Typography>
                  <Typography color="textSecondary">• Rückstandsanalytik</Typography>
                  <Typography color="textSecondary">• Mikrobiologische Untersuchungen</Typography>
                  <Typography color="textSecondary">• Allgemeine chemische Analysen</Typography>
                  <Typography color="textSecondary">• Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
                  <Typography color="textSecondary">• Migrationsanalysen & Verpackungsprüfungen</Typography>
               </Box>
               </>
               }
          />
          <FormControlLabel
             value="bilacon-laboratory"
             disabled={mutableRegistration.portal_access !== "Open"}
             control={<Radio color="primary" />}
             label={
               <>
               <Box className={classes.rahmenprogrammA}>
                  <Typography
                    color="textPrimary"
                  >
                    Labor Besichtigung
                  </Typography>
               </Box>
               <Box className={classes.rahmenprogrammB}>
                  <Typography color="textSecondary">• Transfer zum bilacon-Labor in Berlin mit einer exklusiven Führung durch die Einrichtungen</Typography>
               </Box>
               </>
               } />
          <FormControlLabel
             value="bilacon-none"
             disabled={mutableRegistration.portal_access !== "Open"}
             control={<Radio color="primary" />}
             label={
               <Typography
                 color="textPrimary"
               >
                 Keine Teilnahme am Nachmittagsprogramm
                 </Typography>
               } />
          </RadioGroup>
          </FormControl>
        </Box>
        <Box style={{ height: 40 }} />
        */}


        <Typography
          color="textPrimary"
          align="left"
          style={{ fontWeight: "bold", marginBottom: 10 }}
        >
          Kontakt Information
        </Typography>
        <Typography color="textSecondary" align="left">
          Ihre persönlichen Kontakt Informationen
        </Typography>

        <Box style={{ height: 10 }} />


        <TextField
          style={{ marginBottom: 10 }}
          size="small"
          label="Name  (max. 35)"
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          inputProps={{
              maxLength: 35,
            }}
          value={mutableRegistration?.name}
          onChange={(event) =>
            setMutableRegistration({
              ...mutableRegistration,
              name: event.target.value,
            })
          }
        />


        <TextField
          style={{ marginBottom: 10 }}
          size="small"
          label="E-Mail Addresse"
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          value={mutableProfile.email}
          onChange={(event) =>
            setMutableProfile({
              ...mutableProfile,
              email: event.target.value,
            })
          }
        />

        <TextField
          style={{ marginBottom: 10 }}
          size="small"
          label="Mobilfunk-Nr."
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          value={mutableProfile.mobile_phone_number}
          onChange={(event) =>
            setMutableProfile({
              ...mutableProfile,
              mobile_phone_number: event.target.value,
            })
          }
        />

        <Divider style={{marginBottom: 10}}/>

        <TextField
          style={{ marginBottom: 10 }}
          size="small"
          label="Company Brand Name (without legal form such as GmbH, AG, SE, etc.)"
          variant="filled"
          disabled={true}
          InputProps={{
            disableUnderline: true,
          }}
          inputProps={{
              maxLength: 25,
            }}
          value={mutableRegistration?.company}
          onChange={(event) =>
            setMutableRegistration({
              ...mutableRegistration,
              company: event.target.value,
            })
          }
        />


        <TextField
          style={{ marginBottom: 10 }}
          size="small"
          label="Unternehmes-Addresse"
          variant="filled"
          disabled={true}
          InputProps={{
            disableUnderline: true,
          }}
          inputProps={{
              maxLength: 255,
            }}
          value={mutableProfile.address}
          onChange={(event) =>
            setMutableProfile({
              ...mutableProfile,
              address: event.target.value,
            })
          }
        />

        <TextField
          style={{ marginBottom: 10 }}
          size="small"
          label="Unternehmens-Tel. (Switchboard)"
          variant="filled"
          disabled={true}
          InputProps={{
            disableUnderline: true,
          }}
          value={mutableProfile.phone_number}
          onChange={(event) =>
            setMutableProfile({
              ...mutableProfile,
              phone_number: event.target.value,
            })
          }
        />



      <Box style={{ height: 20 }} />
      <Button
        disabled={
        (
          JSON.stringify(registrationFactory.toJSON(registration)) ===
          JSON.stringify(mutableRegistration)
          &&
          JSON.stringify(profileFactory.toJSON(profile)) ===
          JSON.stringify(mutableProfile)
        )
        }
        color="primary"
        variant="contained"
              onClick={() =>
                authToken &&
                saveProfileInformation(
                  authToken,
                  Config.getInstance().getEventID(),
                  Config.getInstance().getRegistrationID(),
                  profileFactory.fromJSON(mutableProfile),
                  registrationFactory.fromJSON(mutableRegistration),
                )}
      >
        Speichern
      </Button>
    </Box>
  );
};
